export default __webpack_public_path__ + "static/media/Logo.f6bef17a.png";